import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadRoleBasedProjectRates,
  WriteRoleBasedProjectRates,
} from "@/schemas/roleBasedProjectRates";

export const RoleBasedProjectRatesService = new APIService<
  ReadRoleBasedProjectRates,
  WriteRoleBasedProjectRates
>(API.RoleBasedProjectRates);
